// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/css/reset.css';
import * as echarts from 'echarts'
import 'echarts-gl'
import store from './store/index'
import './permission'

ElementUI.Dialog.props.lockScroll.default = false

import {
  request,
  requestdown,
  requestFile
} from '@/api/http'
Vue.prototype.$request = request
Vue.prototype.$requestDown = requestdown
Vue.prototype.$requestFile = requestFile
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
// router.beforeEach((to,from,next)=>{
//   let tokens = sessionStorage.getItem("tokens")
//   console.log(to,'tototototo')
//   if(tokens){
//     if(to.path == '/login'){
//       next({name:'index'})
//     }else{
//       next()
//     }
//   }else{
//     if(to.path != '/login'){
//       next({path:"/login"})
//     }else{
//       next()
//     }
//   }
// })
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js